import { render, staticRenderFns } from "./VehicleInspection.vue?vue&type=template&id=31bed304&scoped=true"
import script from "./VehicleInspection.vue?vue&type=script&lang=js"
export * from "./VehicleInspection.vue?vue&type=script&lang=js"
import style0 from "./VehicleInspection.vue?vue&type=style&index=0&id=31bed304&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bed304",
  null
  
)

export default component.exports